module.exports = __webpack_public_path__ + "fonts/Manrope-800-latin30.02fde8a.woff2";